import { render, staticRenderFns } from "./AcceptedCommuneInfo.vue?vue&type=template&id=718a26db&"
import script from "./AcceptedCommuneInfo.vue?vue&type=script&lang=ts&"
export * from "./AcceptedCommuneInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports